import { IMongoDocument } from "@/types/global"

export const CURRENCY = {
  STAR: "star",
  TON: "ton",
  GOLDEN_DUST: "goldenDust",
  LABR: "labr"
} as const
export type ICurrency = (typeof CURRENCY)[keyof typeof CURRENCY]

enum BALANCE_CHANGE_REASON {
  WITHDRAW = "withdraw",
  MINE_REWARD = "mine-reward",
  LEADERBOARD_REWARD = "leaderboard",
  STAKING = "staking",
  CLAN = "clan",
  DEPOSIT = "deposit",
  WEMINE_LABR_LEADERBOARD = "weMine-labr-leaderboard",
  AUCTION = "auction"
}

enum BALANCE_DIRECTION {
  INCOME = "income",
  OUTCOME = "outcome"
}

export interface IUserBalance
  extends IMongoDocument,
    Record<ICurrency, number> {}

export interface INewBalance extends Record<ICurrency, number> {}

export enum CARD_GAME_CURRENCY {
  GOLDEN_DUST = "goldenDust",
  TON = "ton"
}

export type ICardGameBalance = Record<CARD_GAME_CURRENCY, number>
export interface IBalanceChangeRecord extends IMongoDocument {
  userId: string
  currency: ICurrency
  amount: number
  direction: BALANCE_DIRECTION
  type: BALANCE_CHANGE_REASON
  description: string
  name: string
}
